$(function() {
    let topSliterOwl = $('#home-slider').owlCarousel({
        lazyLoad: true,
        lazyLoadEager: true,
        center: true,
        margin: 5,
        stagePadding: 0,
        rtl: true,
        dots: true,
        responsive: {
            0: {items: 1},
            320: {items: 1},
            600: {items: 2}
        },
        autoplay: true,
        autoplayTimeout: 10000,
        autoplayHoverPause: true,
        loop: true,
        animateIn: 'moveIn',
        animateOut: 'moveOut',
    });

    // timer
    $('[id^="count-down-timer-"]').each(function (i, obj) {
        let elementId = $(this).attr('id');
        let datetime = $(this).attr('datetime');

        var countDownDate = new Date(datetime).getTime();

        // Update the count down every 1 second
        var x = setInterval(function () {

            // Get todays date and time
            var now = new Date().getTime();

            // Find the distance between now an the count down date
            var distance = countDownDate - now;

            // Time calculations for days, hours, minutes and seconds
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);

            hours = hours < 10
                ? '0' + hours.toString().toPersianDigits()
                : hours.toString().toPersianDigits();

            minutes = minutes < 10
                ? '0' + minutes.toString().toPersianDigits()
                : minutes.toString().toPersianDigits();

            // Output the result in an element with id="demo"
            document.getElementById(elementId).innerHTML = hours.toString().toPersianDigits() + " : "
                + minutes.toString().toPersianDigits() + " : " + seconds.toString().toPersianDigits();

            // If the count down is over, write some text
            if (distance < 0) {
                clearInterval(x);
                document.getElementById(elementId).innerHTML = "منقضی شده";
            }
        }, 1000);

    });

    // copy-it
    var clipboard = new ClipboardJS('.copy-it', {
        text: function (trigger) {
            return $(trigger).text().trim();
        }
    });

    clipboard.on('success', function (e) {
        $(e.trigger).tooltip({
            title: 'کپی شد',
            placement: 'bottom',
            trigger: 'manual',
            container: 'body'
        }).tooltip('show');

        setTimeout(function () {
            $(e.trigger).tooltip('hide').tooltip('dispose');
        }, 2000);
    });

    $(document).on('click', '.poll-dont-want', function () {
        var id = $('#pool-modal').data('purchase');
        var token = $('#pool-modal').data('token');
        $(this).parent().parent().remove();
        $.ajax({
            url: window.BASE_URL + '/pool-survey/' + id + '/' + token + '/set-dont-want',
            method: 'POST',
            cache: false,
            dataType: 'json',
        });
    });

    // Search bar
    const searchBar = document.getElementById('home-search-bar');
    const searchBarTopOffset = searchBar.offsetTop;
    const searchBarTopOffsetStart = searchBarTopOffset - 5;

    const updateSearchbar = () => {
        if (window.scrollY > searchBarTopOffsetStart && !searchBar.classList.contains('fix')) {
            searchBar.classList.add('fix')
        }

        if (window.scrollY <= searchBarTopOffsetStart && searchBar.classList.contains('fix')) {
            searchBar.classList.remove('fix');
        }
    }
    updateSearchbar();
    window.addEventListener('scroll', updateSearchbar);
});